import { getAllSymbolNotes, saveSymbolNote, deleteSymbolNote } from './http/symbolNotes';
import type { QueryObserverOptions, UseMutationOptions } from '@tanstack/react-query';

// Query key constants
export const SYMBOL_NOTES = 'symbol-notes';

/**
 * Query options for fetching all symbol notes for the current user.
 * Returns a Map for efficient lookup by symbol.
 */
export function getAllSymbolNotesQuery(): QueryObserverOptions<Map<string, string>> {
    return {
        queryKey: [SYMBOL_NOTES],
        queryFn: async () => {
            const notesRecord = await getAllSymbolNotes();
            return new Map(Object.entries(notesRecord));
        },
        staleTime: 1000 * 60 * 5, // 5 minutes
    };
}

/**
 * Mutation options for saving a symbol note
 */
export function getSaveSymbolNoteMutation(): UseMutationOptions<
    void,
    Error,
    { symbol: string; note: string },
    { previousNotes: Map<string, string> | undefined }
> {
    return {
        mutationFn: async ({ symbol, note }) => {
            if (note.trim() === '') {
                await deleteSymbolNote(symbol);
            } else {
                await saveSymbolNote(symbol, note);
            }
        },
    };
}
